import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

const PATH_TEMPLATE = '/questionnaires/{questionnaireId}/section-template/{sectionTemplateId}/pdf-fill-json';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = ThisApi['params'];

const getPdfFillJson = async ({ questionnaireId, sectionTemplateId }: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, {
    questionnaireId,
    sectionTemplateId,
  });
  const response = await formsBackendClient.get(path);
  return response.data;
};

export default getPdfFillJson;
